import { CommonModule, ViewportScroller } from '@angular/common';
import { AfterContentInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { KENDO_DIALOGS, WindowModule, WindowRef } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { EditorModule } from '@progress/kendo-angular-editor';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { AutoFocusDirective } from '../../../directives/auto-focus.directive';
import { PermissionType } from '../../../models/models.lib';
import { CasiCloseOptions, FormModes } from '../../../common/constants.lib';
import { Subscription } from 'rxjs';
import { LoggerService } from '../../../shared/logger.service';

@Component({
  selector: 'casi-add-edit-permission-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    RouterLink, RouterLinkActive,
    // WindowModule,
    EditorModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective,
    KENDO_DIALOGS
  ],
  templateUrl: './add-edit-permission-modal.component.html',
  styleUrl: './add-edit-permission-modal.component.scss'
})
export class AddEditPermissionModalComponent implements OnInit, OnDestroy, AfterContentInit {

  private _permission: PermissionType | undefined;

  @Input() title: string = 'Title Not Set';

  @Input({ required: true }) set permission(val: PermissionType) {
    this._permission = val;
    this.permissionForm.patchValue(this._permission);
  }
  get permission(): PermissionType | undefined {
    return this._permission;
  };

  private _mode: FormModes = FormModes.NOTSET;
  @Input({ required: true }) set mode(val: FormModes) {
    this._mode = val;
  }
  get mode(): FormModes {
    return this._mode;
  };

  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();
  @Output() closeForm: EventEmitter<void> = new EventEmitter();

  permissionForm: FormGroup;

  private _subs: Subscription[] = [];

  constructor(
    // public override dialog: DialogRef,
    // public window: WindowRef,
    private fb: FormBuilder,
    private logger: LoggerService,
    private scroller: ViewportScroller
  ) {
    // super(window);
    this.permissionForm = this.fb.group(
      {
        id: [null, []],
        entity: [null, [Validators.required]],
        action: [null, [Validators.required]]
      }
    );
  }


  //#region Form

  get f() {
    return this.permissionForm.controls;
  }
  get entity() {
    return this.permissionForm.get('entity');
  }
  get action() {
    return this.permissionForm.get('action');
  }

  //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnInit...');
    this._subs.forEach(s => s.unsubscribe());
  }

  ngAfterContentInit(): void {
    this.logger.debug('ngAfterContentInit...');
    // this.scroller.scrollToPosition([10, 10]);
    setTimeout(() => {
      // document.body.scrollTo({ top: 0, behavior: 'smooth' });
      this.scroller.scrollToPosition([0, 0]);
      // this.pForm.nativeElement.scrollTop();
    }, 50);
  }

  public onCancelAction(): void {
    this.logger.debug(`onCancelAction...`);
    this.closeForm.emit();
    // this.window.close({ text: CasiCloseOptions.Cancelled });
  }

  public onSaveAction(): void {
    this.logger.debug(`onSaveAction...`, this.permissionForm.value);
    if (this.permissionForm.status !== 'INVALID')
      this.submitForm.emit(this.permissionForm);
    // this.window.close({ text: CasiCloseOptions.Saved });
  }

}
